import ReactPlayerLoader from "@brightcove/react-player-loader";
import styled from "styled-components";
import { brightcoveUrlParser } from "../utils/brightcoveUrlParser";

const PlayerWrapper = styled("div")({
  width: "100%",
  minHeight: "360px",
  ".bc-player-default_default": {
    width: "100%",
    minHeight: "360px",
  },
});

const FringePlayer = ({ contentUrl }) => {
  const { accountId, videoId, playerId } = brightcoveUrlParser(contentUrl);

  const onSuccess = (success) => {
    console.log(success);
  };

  return (
    <PlayerWrapper>
      <ReactPlayerLoader
        onSuccess={onSuccess}
        accountId={accountId}
        player={playerId}
        embed="default"
        controls=""
        videoId={videoId}
        playlistId=""
        applicationId=""
        className="vjs-fluid"
      />
    </PlayerWrapper>
  );
};

export default FringePlayer;
